export const environment = {
  production: true,
  environmentName: 'prod',
  apiUrl: 'https://odin.posta.fo',
  dibsUrl: 'https://vanir.posta.fo',
  beraUrl: 'https://odin.posta.fo'
};